<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Personal information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="Personal information"></el-step>
                  <el-step title="Authentication"></el-step>
                  <el-step title="Bank information"></el-step>
                  <el-step title="Additional information"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-12 col-lg-12"
              style="margin-left: 10%; margin-top: 40px"
            >
              <!-- <el-page-header content="Authentication"> </el-page-header> -->
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-row>
                  <el-row>
                    <el-col :span="16">
                      <el-form-item
                        label="Passport number (or U.S. driver's license number)"
                        prop="passport"
                      >
                        <el-input
                          v-model="formData.passport"
                          placeholder="Passport number (or U.S. driver's license number)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item
                        label="Identification documents"
                        prop="idfileType"
                      >
                        <el-radio-group
                          v-model="formData.idfileType"
                          size="medium"
                        >
                          <el-radio
                            v-for="(item, index) in idfileTypeOptions"
                            :key="index"
                            :label="item.value"
                            :disabled="item.disabled"
                            >{{ item.label }}</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="International passport/US driver's license"
                        label-width="0"
                        prop="idFile"
                        required
                      >
                        <FileUpload
                          emitaction="setidfileurl"
                          :fileurl="formData.idFile"
                          v-on:emitaction="setidfileurl"
                        ></FileUpload>
                        <!-- <el-upload
                          ref="idFile"
                          class="avatar-uploader"
                          :file-list="idFilefileList"
                          :action="idFileAction"
                          :before-upload="idFileBeforeUpload"
                          list-type="picture"
                        >
                          <img
                            v-if="formData.idFile"
                            :src="formData.idFile"
                            class="avatar"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                        </el-upload> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="Selfie"
                        prop="selfie"
                        required
                      >
                        <FileUpload
                          emitaction="setselfiefile"
                          :fileurl="formData.selfie"
                          v-on:emitaction="setselfiefileurl"
                        ></FileUpload>
                        <!-- <el-upload
                          class="avatar-uploader"
                          ref="selfie"
                          :file-list="selfiefileList"
                          :action="selfieAction"
                          :before-upload="selfieBeforeUpload"
                        >
                          <img
                            v-if="formData.selfie"
                            :src="formData.selfie"
                            class="avatar"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                        </el-upload> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="Proof of residence"
                        prop="addrProve"
                        required
                      >
                        <FileUpload
                          emitaction="setselfiefile"
                          :fileurl="formData.addrProve"
                          v-on:emitaction="setprovefileurl"
                        ></FileUpload>
                        <!-- <el-upload
                          class="avatar-uploader"
                          ref="addrProve"
                          :file-list="addrProvefileList"
                          :action="addrProveAction"
                          :before-upload="addrProveBeforeUpload"
                          list-type="picture"
                        >
                          <img
                            v-if="formData.addrProve"
                            :src="formData.addrProve"
                            class="avatar"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                        </el-upload> -->
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item
                      label="Tip: Make sure your photo meets the following requirements! Otherwise you may not pass the verification"
                    >
                      <p>i, International passport/US driver's license</p>
                      <p>1, Photo must be less than 3.6MB, &lt; 3200px * 4000px</p>
                      <p>
                        2, The photo must be larger than 500KB, > 800px * 1000px
                      </p>
                      <p>
                        3, The format of the photo must be .jpg, .jpeg or
                        .png.(PDF format is not accepted)
                      </p>
                      <p>
                        4, The photo should be well lit and in focus（ Our
                        system cannot recognize blurry photos!）
                      </p>
                      <p>
                        5, Photos should cover the entire file and clearly show
                        the required information
                      </p>
                      <p>6, No filters, cropping, watermarks</p>
                      <p>7, Keep your head straight and no rotation</p>
                      <p>ii, Selfie</p>
                      <p>
                        A photo of yourself with the entire face clearly
                        visible. Take off any accessories such as glasses when
                        taking photos. The photo should be well lit and in
                        focus.
                      </p>
                      <p>iii, proof of residence</p>
                      <p>
                        Please upload utility bills, bank statements,
                        cable/internet bills that include your name and address.
                      </p>
                    </el-form-item>
                    <!-- <el-form-item label="提示：请注意文件需要满足以下要求，否则可能会导致身份验证失败！">
                      <p>一、护照/美国驾驶证： </p><p>1、图像文件尺寸小于 3.6 MB, 宽小于3200px * 高4000px </p>
                        <p>2、图像文件尺寸>500 KB, >宽1000px * 高1280px</p>
                      <p>3、文件格式必须是 .jpg 或 .jpeg. (不接受PDF格式)</p>
                      <p>4、照片必须彩色、清晰。</p>
                      <p>5、照片不可裁剪、加水印、滤镜、美化、PS</p>
                      <p>6、照片应包含完整的文档内容，并能清楚显示所需信息</p>
                      <p>7、人物头部竖直，不可旋转或水平 </p><p>二、自拍照</p>
                      <p>请上传正面自拍照。照片必须为彩色，清晰，背景为浅色。拍照时请不要佩带帽子、眼镜和首饰。</p>
                      <p>三、地址证明</p>
                      <p>请提供 3个月内银行对账单清晰扫描。扫描件必须明确包括申请人居住地址以及名称。</p>
                    </el-form-item> -->
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 40px">
                  <el-col :span="6" :offset="0"
                    ><el-button @click="goback">Previous</el-button></el-col
                  >
                  <el-col :span="10" :offset="2">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
                <div class="row">
                  <div class="col-xl-2 col-lg-2" style="margin-top: 40px">
                    <el-form-item size="large"> </el-form-item>
                  </div>
                  <div class="col-xl-4 col-lg-4" style="margin-top: 40px"></div>
                </div>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import FileUpload from "../../components/plugins/FileUpload2.vue";
import {
  otc_auth_status,
  get_auth_info,
  att_auth_info,
} from "../../plugins/api/account_otc";
export default {
  components: { FileUpload },
  props: [],
  data() {
    return {
      activeStep: 1,
      formData: {
        passport: undefined,
        idfileType: "",
        idFile: "",
        selfie: "",
        addrProve: "",
      },
      rules: {
        passport: [
          {
            required: true,
            message: "Passport number (or U.S. driver's license number)",
            trigger: "blur",
          },
        ],
        idfileType: [
          {
            required: true,
            message: "Identification documents Cannot be empty",
            trigger: "change",
          },
        ],
      },
      idFileAction: "https://jsonplaceholder.typicode.com/posts/",
      idFilefileList: [],
      selfieAction: "https://jsonplaceholder.typicode.com/posts/",
      selfiefileList: [],
      addrProveAction: "https://jsonplaceholder.typicode.com/posts/",
      addrProvefileList: [],
      idfileTypeOptions: [
        {
          label: "Passport",
          value: 1,
        },
        {
          label: "U.S. driver's license",
          value: 2,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_auth_info().then((res_query) => {
      if (res_query.data.passport) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      }
    });
  },
  mounted() {},
  methods: {
    setidfileurl(url) {
      this.formData.idFile = url;
    },
    setselfiefileurl(url) {
      this.formData.selfie = url;
    },
    setprovefileurl(url) {
      this.formData.addrProve = url;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        att_auth_info(this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/person/step3");
          } else {
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    idFileBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    selfieBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    addrProveBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    goback() {
      this.$router.push("/reg/person/step1");
    },
  },
};
</script>
<style>
.el-icon-plus:before {
  top: 70px;
  position: relative;
}
.el-upload__tip {
  line-height: 1.2;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>